export enum SuppliesInventoryConfigStatus {
  Active = "active",
  Paused = "paused",
  Archived = "archived",
}
